import { useQuery } from 'react-query';
import { getPrivateApi } from '../services/api';
import { queryKeys } from '../services/query-key/query-keys';

export function usePaymentMethods(customerId?: string) {
  return useQuery(queryKeys.paymentMethods(customerId), async () => {
    const api = getPrivateApi();
    const response = await api.getPaymentMethods({ customerId });
    return response.paymentMethods;
  });
}
